var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fill: "#303030", fillRule: "evenodd", d: "M6.142 12.108l-2.15-2.076-1.408 3.559 3.54-1.464.018-.019zm.345-.345l6.692-6.691c.348-.369.28-.964-.087-1.313l-.017-.017-.596-.597c-.37-.348-1.095-.466-1.421-.195L4.69 9.317l2.153 2.077-.357.37zm-2.14-2.102l-.345.344-.008.021.353-.365zm9.435-6.626c.766.73.831 1.975.104 2.744L6.83 12.834c-.218.215-1.644.811-4.28 1.787a1 1 0 0 1-1-1.09c.947-2.604 1.529-4.015 1.744-4.233l7.055-7.055c.776-.655 2.073-.523 2.813.173l.619.619zM9.659 4.349l2.121 2.12-.707.708-2.121-2.121.707-.707z" })
  );
});